import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationAuthGuard } from '@experian-digital/affordability-library';

import { DepartmentResolver } from '@portal-shared/guards/department.resolver';
import { SelectDepartmentGuard } from '@portal-shared/guards/select-department.guard';

import { SignoutRedirectComponent } from '@portal-shared/components/signout-redirect/signout-redirect.component';
import { CookiePolicyComponent } from './advisor/pages/cookie-policy/cookie-policy.component';
import { UnauthorisedComponent } from './advisor/pages/unauthorised/unauthorised.component';
import { APP_ROUTES } from './advisor/routes';

const routes: Routes = [
  {
    path: '',
    canActivate: [ApplicationAuthGuard],
    loadChildren: () => import('./advisor/advisor.module').then((module) => module.AdvisorModule),
  },
  {
    path: APP_ROUTES.signoutRedirect,
    component: SignoutRedirectComponent,
  },
  {
    path: APP_ROUTES.unauthorised,
    component: UnauthorisedComponent,
  },
  {
    path: APP_ROUTES.cookiePolicy,
    component: CookiePolicyComponent,
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
  providers: [DepartmentResolver, SelectDepartmentGuard],
})
export class AppRoutingModule {}
